export default __webpack_public_path__ + "ef0573222426ce050c9aea8699607dd3.png";